<template>
  <article>
    <NOSComponent ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <div class="scroll">
      <!-- Advanced OTP 인증 -->
      <!-- 영업점에서 발급받은 Advanced OTP로 본인인증을 합니다. -->
      <!-- 기기에 표시되는 OTP 인증번호를 입력하세요. -->
      <contents-header
        :bgType="true"
        :noRadius="true"
        :title-img2="true"
        customer-css="mb0"
        title="AOTP-02-01-01-01"
        description="AOTP-02-01-01-02"
        description2="AOTP-02-01-01-03"
      >
        <template #img2>
          <i class="icon icon-advanced-otp-touch" />
        </template>
      </contents-header>

      <article class="contents">
        <div class="form">
          <div class="form-row">
            <div class="item-tit">
              {{ /*OTP 기기 일련번호*/ $t("MOTP-01-07-05-03") }}
            </div>
            <div class="item-desc">
              <div class="form-text-field otp">
                <div class="input-text-field">
                  <input type="text" id="name" class="form-control" :value="getCheckOtp.in.otpUniqIdnfiNo" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="form-text-field">
            <label for="name" class="form-label">{{ /*인증번호 */ $t("MOTP-01-07-05-04") }}</label>
            <div class="input-text-field">
              <advanced-otp-input
                :NOS_INSTANCE_REFERANCE="NOS_INSTANCE"
                :is-input-hidden="false"
                />
            </div>
          </div>
          <div class="info info-help" @click="infoOpened=true"><i class="icon icon-help" />{{/*인증번호 확인 방법*/$t("AOTP-02-01-01-04")}}</div>
        </div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md normal">{{ /*인증하기*/ $t("MOTP-01-07-05-05") }}</button>
    </div>
    <!-- action sheet 들어 가는 곳 -->
    <action-sheet :opened.sync="infoOpened" :no-negative-button="false" confirm="MCOM-0000003" title="AOTP-02-01-01-04">
      <template #content>
        <ol class="olist olist-number-type2">
          <li class="num">
            {{/*Advanced OTP에 Unlock Button을 길게 누르면 기기 전원이 켜집니다.*/$t("AOTP-02-01-01-05")}}
          </li>
          <li class="num">
            {{/*사용자 PIN을 입력한 후 Unlock Button을 누릅니다.*/$t("AOTP-02-01-01-06")}}
          </li>
          <li class="num">
            {{/*화면에 \"Adv_OtP\"가 표시되면, OTP모드를 선택할 수 있습니다.*/$t("AOTP-02-01-01-07")}}
          </li>
          <li class="num">
            {{/*Button 1(OTP)를 누르면 기기 화면에 7자리 인증번호가 표시됩니다.*/$t("AOTP-02-01-01-08")}}
          </li>
          <li class="num">
            {{/*기기에서 확인한 인증번호를 입력하시면 됩니다.*/$t("AOTP-02-01-01-09")}}
          </li>
        </ol>
        <i class="icon icon-adv-otp-touch" />
      </template>
    </action-sheet>
    <!--// end -->
  </article>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Common from "@/components/basic/Common";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import AdvancedOtpInput from "@/components/page/common/AdvancedOtpInput";
export default {
  extends: Common,
  name: "AdvancedOTPCertn",
  components: {
    NOSComponent,
    AdvancedOtpInput
  },
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
  },
  computed: {
    ...mapGetters("auth/commMotpCertn", ["getCheckOtp"]),
  },
  data() {
    return {
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
      infoOpened: false
    };
  },
  mounted() {
      // 초기화
    this.act012_commMotpCertn();
    // tokenOTP 일련번호
    this.act011_commMotpCertn();
    this.NOS_INSTANCE.init();
    this.$store.state.common.supplCertn.supplCertn.certnMethdDstcd = this.$store.state.sessionInfo.userInfo.scurtyDeviVndrDstcd;
    this.$store.state.common.supplCertn.supplCertn.advancedOTP.synczModDstcd = "RO";
    this.$store.state.common.supplCertn.cmmCertn.bizDscdForNosKeypadOtp = "AdvancedOTPCertn";
    this.$store.state.auth.commMotpCertn.checkOtp.in.bizDscd = this.bizDscd; // act010_commMotpCertn 에서 사용.
    this.$store.state.auth.commMotpCertn.successFncForBiz = this.successFnc; // act010_commMotpCertn 에서 사용.
  },
  methods: {
      ...mapActions("auth/commMotpCertn", ["act011_commMotpCertn", "act012_commMotpCertn"]),
  }
};
</script>
